'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Slider = function (_React$Component) {
  (0, _inherits3.default)(Slider, _React$Component);

  function Slider() {
    (0, _classCallCheck3.default)(this, Slider);
    return (0, _possibleConstructorReturn3.default)(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
  }

  (0, _createClass3.default)(Slider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          lineHeight = _props.lineHeight,
          lineSpacing = _props.lineSpacing,
          width = _props.width;
      var yOffset = lineSpacing + lineHeight;
      return _react2.default.createElement(_base2.default, (0, _extends3.default)({
        typeClassName: 'BurgerSlider'
      }, this.props), _react2.default.createElement(_style2.default, {
        styleId: '1314878248',
        css: '.BurgerSlider{display:inline-block;}.BurgerSlider .BurgerInner{top:' + lineHeight / 2 + 'px;}.BurgerSlider .BurgerInner:before{top:' + yOffset + 'px;-webkit-transition-property:-webkit-transform,opacity;-webkit-transition-property:transform,opacity;transition-property:transform,opacity;-webkit-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:0.15s;transition-duration:0.15s;}.BurgerSlider .BurgerInner:after{top:' + yOffset * 2 + 'px;}.BurgerSlider.BurgerActive .BurgerInner{-webkit-transform:translate3d(0,' + yOffset + 'px,0) rotate(45deg);-ms-transform:translate3d(0,' + yOffset + 'px,0) rotate(45deg);transform:translate3d(0,' + yOffset + 'px,0) rotate(45deg);}.BurgerSlider.BurgerActive .BurgerInner:before{-webkit-transform:rotate(-45deg) translate3d(' + width / -7 + 'px,' + lineSpacing * -1 + 'px,0);-ms-transform:rotate(-45deg) translate3d(' + width / -7 + 'px,' + lineSpacing * -1 + 'px,0);transform:rotate(-45deg) translate3d(' + width / -7 + 'px,' + lineSpacing * -1 + 'px,0);opacity:0;}.BurgerSlider.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-90deg);-ms-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-90deg);transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-90deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/slider.js */',
        dynamic: [lineHeight / 2, yOffset, yOffset * 2, yOffset, width / -7, lineSpacing * -1, yOffset * -2]
      }));
    }
  }]);
  return Slider;
}(_react2.default.Component);

exports.default = Slider;
Slider.defaultProps = _defaultProps2.default;
module.exports = exports['default'];